/* =====================================================================
   JESUS GLOBAL — theme behaviour
   Gates intro, scroll reveals, sticky nav, product-card image swap,
   and the product-page gallery.
   Animates transform/opacity only.
   ===================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Gates intro (home page only) ---------- */
  var gates = document.querySelector('.gates');
  if (gates) {
    var body = document.body;
    var open = function () {
      if (body.classList.contains('opening')) return;
      requestAnimationFrame(function () {
        body.classList.add('opening');
        document.querySelectorAll('.hero .reveal').forEach(function (el) {
          el.classList.add('in');
        });
        setTimeout(function () { body.classList.add('opened'); }, REDUCED ? 0 : 3000);
      });
    };
    window.addEventListener('load', open);
    setTimeout(open, 1400);
  }

  /* ---------- Sticky nav ---------- */
  var nav = document.getElementById('nav');
  if (nav) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        nav.classList.toggle('stuck', window.scrollY > 40);
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- Scroll reveals ---------- */
  var items = document.querySelectorAll('.reveal:not(.hero .reveal)');
  if (REDUCED || !('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Product card: hover swap + touch dots ---------- */
  document.querySelectorAll('.card').forEach(function (card) {
    var media = card.querySelector('.card-media');
    if (!media) return;
    var a = media.querySelector('.shot-a');
    var b = media.querySelector('.shot-b');
    if (!a) return;

    function show(which) {
      if (!b) return;
      a.classList.toggle('is-active', which === 0);
      b.classList.toggle('is-active', which === 1);
      var dots = media.querySelectorAll('.dot');
      if (dots.length === 2) {
        dots[0].classList.toggle('sel', which === 0);
        dots[1].classList.toggle('sel', which === 1);
      }
    }

    card.addEventListener('mouseenter', function () { show(1); });
    card.addEventListener('mouseleave', function () { show(0); });
    card.addEventListener('focusin',  function () { show(1); });
    card.addEventListener('focusout', function () { show(0); });

    media.querySelectorAll('.dot').forEach(function (dot, n) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();   // never follow the product link
        show(n);
      });
    });
  });

  /* ---------- Product page gallery ---------- */
  var stage = document.getElementById('pdp-stage');
  if (stage) {
    var shots = stage.querySelectorAll('img');
    document.querySelectorAll('.pdp-thumb').forEach(function (thumb, n) {
      thumb.addEventListener('click', function () {
        shots.forEach(function (s, k) { s.classList.toggle('is-active', k === n); });
        document.querySelectorAll('.pdp-thumb').forEach(function (t) { t.classList.remove('sel'); });
        thumb.classList.add('sel');
      });
    });
  }

  /* ---------- Marquee: duplicate the track so the loop is seamless ---------- */
  var track = document.getElementById('marquee-track');
  if (track && !REDUCED) {
    track.innerHTML = track.innerHTML + track.innerHTML;
  }
})();
